var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReviews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reviews"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.5 30.9375V5.625C2.5 4.85156 2.745 4.18922 3.235 3.63797C3.725 3.08672 4.31333 2.81156 5 2.8125H25C25.6875 2.8125 26.2763 3.08813 26.7663 3.63938C27.2563 4.19063 27.5008 4.8525 27.5 5.625V22.5C27.5 23.2734 27.255 23.9358 26.765 24.487C26.275 25.0383 25.6867 25.3134 25 25.3125H7.5L2.5 30.9375ZM11.3438 20.0391L15 17.543L18.6562 20.0391L17.6875 15.3633L20.9375 12.1992L16.6562 11.8125L15 7.38281L13.3438 11.8125L9.0625 12.1992L12.3125 15.3633L11.3438 20.0391Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviews);
export default __webpack_public_path__ + "static/media/Reviews.5467987386ee4760b68b1dbddeb35e52.svg";
export { ForwardRef as ReactComponent };